import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { Observable, map, throwError } from 'rxjs';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';

const COLLECTION_NAME = 'dynamic_natural_person';

export type User = {
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    job?: string;
    obj?: any;
    mobile?:string;
    function?:string;
    civility?:any,
    isRequestedDeletion?:boolean
};

@Injectable()
export class UserRepository {
    constructor(
        private dynamicDocumentService: DynamicDocumentService,
        private datePipe: DatePipe
    ) {}
    getCurrentUser(): Observable<User> {
        const userId = localStorage.getItem('userid');
        if (!userId) {
            return throwError(() => new Error('User not found'));
        }

        return this.dynamicDocumentService
            .findById(COLLECTION_NAME, userId, true)
            .pipe(map((res) => this.convertUser(res)));
    }

    save(user: User): Observable<User> {
        user.obj.creationDate = this.datePipe.transform(
            user.obj.creationDate,
            "yyyy-MM-dd'T'HH:mm:ss"
        );
        user.obj.updatingDate = this.datePipe.transform(Date.now(), "yyyy-MM-dd'T'00:00:00");
        user.obj.dateOfLastConnectionToTheIntranetSite = this.datePipe.transform(
            user.obj.dateOfLastConnectionToTheIntranetSite,
            "yyyy-MM-dd'T'HH:mm:ss"
        );
        user.obj.resetTokenDateTime = this.datePipe.transform(
            user.obj.resetTokenDateTime,
            "yyyy-MM-dd'T'HH:mm:ss"
        );
        user.obj.firstName = user.firstName;
        user.obj.lastName = user.lastName;
        user.obj.email = user.email;
        user.obj.phone = user.phone;
        user.obj.job = user.job;
        user.obj.mobile = user.mobile
        user.obj.civility.parameterId = user.civility
        
        return this.dynamicDocumentService
            .saveDocument(COLLECTION_NAME, user.obj, true)
            .pipe(map((res) => this.convertUser(res)));
    }

    saveOriginal(user: any): Observable<any> {
        delete user['updatingDate'];
        delete user['creationDate'];
        
        return this.dynamicDocumentService
            .saveDocument(COLLECTION_NAME, user, true)
            .pipe(map((res) => this.convertUser(res)));
    }

    //-------------
    convertUser(user: any): User {
        return {
            firstName: user?.firstName,
            lastName: user?.lastName,
            email: user?.email,
            phone: user?.phone,
            job: user?.job,
            obj: user,
            mobile:user?.mobile,
            civility:user?.civility,
            isRequestedDeletion: user?.isRequestedDeletion
        };
    }
}
